<template>
  <svg width="20"
       height="19"
       viewBox="0 0 20 19"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M2.71387 18.1182H11.2305C12.4082 18.1182 12.9883 17.5381 12.9883 16.2549V9.67188C12.9883 8.54688 12.54 7.95801 11.6084 7.83496V5.49707C11.6084 3.44922 12.918 2.32422 14.4824 2.32422C16.0557 2.32422 17.3564 3.44922 17.3564 5.49707V7.35156C17.3564 7.97559 17.7256 8.30078 18.209 8.30078C18.6748 8.30078 19.0439 7.99316 19.0439 7.35156V5.65527C19.0439 2.31543 16.8203 0.707031 14.4824 0.707031C12.1445 0.707031 9.9209 2.31543 9.9209 5.65527V7.80859L2.85449 7.82617C1.66797 7.82617 0.947266 8.40625 0.947266 9.67188V16.2549C0.947266 17.5381 1.52734 18.1182 2.71387 18.1182Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'MinimizeIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
